// extracted by mini-css-extract-plugin
export default {"closing":"closing_closing__pXo2m","button":"closing_button__q9k3p"};